import { ApprovalStatusType } from "../../domain/model/approval-status-type";

export class TrialOverviewWeighingWeightViewModel {
  constructor(
    readonly status: ApprovalStatusType,
    readonly weight: number
  ) { }
}
